import { render, staticRenderFns } from "./CMSBlogCategoryForm.vue?vue&type=template&id=37d91a8e&"
import script from "./CMSBlogCategoryForm.vue?vue&type=script&lang=js&"
export * from "./CMSBlogCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports